import React from 'react';
import './Team.css'

const Team = () => {
    return(
        <div className="team-body">
            Team
        </div>
    )
};

export default Team;